const Footer = ({ homepage }) => (
  <footer className="text-xs text-gray-500 flex justify-between px-10 py-4">
    <span>{homepage.footerText}</span>
    <span>Call: {homepage.phoneNumber}</span>
  </footer>
);

export default Footer;
